<div class="m-portlet">
    <div class="m-portlet__head">
        <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
                <h3 class="m-portlet__head-text" i18n="app.visit.portfolio.comn.details.title.text">Datoteka</h3>
            </div>
        </div>
    </div>
    <div class="m-portlet__body">
        <div>
            <input [formControl]="fcFileName" type="text" placeholder="Ime datoteke" class="form-control" />
        </div>
    </div>
</div>
